import { Module, ActionContext } from 'vuex'
import { RootState, ContactsState } from '../store/state_models'

export const contactsPage: Module<ContactsState, RootState> = {
  namespaced: true,
  state: { contacts: {} },
  getters: {
    getByLocationId: (
      state: ContactsState
    ) => {
      return (locationId: string) => state.contacts[locationId]
    }
  },
  mutations: {
    addUpdate: (state: ContactsState, payload: { [key: string]: any }) => {
      state.contacts[payload.locationId] = payload
    },
    clearAll: (state: ContactsState) => {
      state.contacts = {}
    }
  },
  actions: {
    logout: {
      root: true,
      handler: async (context: ActionContext<ContactsState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<ContactsState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
